import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchCurrencieTypes,
  createCurrencieType,
  //updateComprobanteType,
  //deleteComprobanteType,
} from "../../api/accounting/currencieTypesApi";

export const useCurrencieTypes = () => {
  const queryClient = useQueryClient();

  const {
    data: currencieTypes = [],
    error,
    isLoading,
  } = useQuery({
    queryKey: ["currencieTypes"],
    queryFn: fetchCurrencieTypes,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  const invalidateCache = () => {
    queryClient.invalidateQueries({ queryKey: ["currencieTypes"] });
  };

  const createMutation = useMutation({
    mutationFn: createCurrencieType,
    onSuccess: invalidateCache,
  });

  /*const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateComprobanteType(id, data),
    onSuccess: invalidateCache,
  });*/

  /*const deleteMutation = useMutation({
    mutationFn: deleteComprobanteType,
    onSuccess: invalidateCache,
  });*/

  return {
    currencieTypes,
    error,
    isLoading,
    createMutation,
    //updateMutation,
    //deleteMutation,
  };
};
